import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { Parallax, useParallax } from 'react-scroll-parallax';

const Career = () => {

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.hbspt.forms.create({
                portalId: '7585485',
                formId: 'b8ad7576-0b0e-4cf5-b809-00454f25c641',
                target: '#hubspot-form-container',
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    //     <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js"></script>
    // <script>
    //   hbspt.forms.create({
    //     portalId: "7585485",
    //     formId: "b8ad7576-0b0e-4cf5-b809-00454f25c641"
    //   });
    // </script>

    return (
        <>

            <div className='career-section padding_top_contact bottom'>
                <div className='container'>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div className="career-form-up">
                            <h1>Upload Your CV</h1>
                            <div id="hubspot-form-container"></div>
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                </div>
            </div>
        </>
    )
}

export default Career;